// TODO: possibly add back 'application/zip', 'application/x-7z-compressed', 'application/octet-stream', 'text/*' -- https://gobaker.atlassian.net/browse/PRODUCT-2354
const acceptableObjectStoreApiMimeTypes = [
  'application/msword', // .doc
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
  'application/vnd.ms-excel', // .xls
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
  'application/pdf', // .pdf
  'application/rtf', // .rtf
  'application/xml', // .xml
  'text/xml', // .xml
  'text/csv', // .csv
  'text/plain' // .txt, .log
];

export const proprietaryExtensions = ['.ipf', '.dat', '.bgi', '.prt', '.pbf', '.flb', '.bsm'];

export const acceptedFileTypesLoans = [...acceptableObjectStoreApiMimeTypes, ...proprietaryExtensions];

export const acceptedFileTypeLoansForUpload = Object.fromEntries(acceptedFileTypesLoans.map((type) => [type, []]));
